<div rsWebElevation [elevation]="2" class="card-overview-content">
  <div class="d-flex" [class]="isCollapsed() ? 'collapsed' : 'expanded'">
    <div class="d-flex align-items-center gap-2 primary-text">
      <rs-web-icon [icon]="icon()"></rs-web-icon>
      <span> {{ titleText() | translate }}</span>
      @if (showNotification()) {
        <span class="notification-bubble" aria-hidden="true"></span>
      }
    </div>
    @if (isCollapsed()) {
      <button im-button class="inverted" (click)="toggleCollapsed()">
        {{ buttonText() | translate }}
      </button>
    } @else {
      <rs-web-icon
        [icon]="immomioIconName.Close"
        [size]="20"
        [cursor]="'pointer'"
        (tapped)="toggleCollapsed()"
      ></rs-web-icon>
    }
  </div>
  @if (!isCollapsed()) {
    <ng-content select="[archive-content]"> </ng-content>
  }
</div>
